import React from 'react';
import { GenericCustomVizPlaceholderSvg } from 'apps/sigma2-ui/src/components/svg/GenericCustomVizPlaceholder';
import { GenericCustomVizErrorPlaceholderSvg } from 'apps/sigma2-ui/src/components/svg/GenericCustomVizErrorPlaceholder';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Box } from 'apps/sigma2-ui/src/components/ui/Box';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const HasFailure = () => {
  const language = useLanguage();

  return (
    <Box w="full" display="flex" justifyContent="center">
      <Box maxW="prose" h="full">
        <Spacing
          direction="vertical"
          size={'sm'}
          className="items-center justify-center py-8 px-8 bg-white h-full text-center"
        >
          <GenericCustomVizErrorPlaceholderSvg />

          <S2Typography
            variant="headline-6-alt"
            translatedContent={language.analysisGenericFailureTitle()}
          />

          <S2Typography
            variant="body-7"
            translatedContent={language.analysisGenericFailureBody()}
          />
        </Spacing>
      </Box>
    </Box>
  );
};

export const NotEnoughData = ({ isEventStudy }: { isEventStudy?: boolean }) => {
  const language = useLanguage();

  return (
    <Box w="full" display="flex" justifyContent="center">
      <Box maxW="prose" h="full">
        <Spacing
          direction="vertical"
          size={'sm'}
          className="items-center justify-center py-8 px-8 bg-white h-full text-center"
        >
          <GenericCustomVizPlaceholderSvg />

          <S2Typography
            variant="headline-6-alt"
            translatedContent={
              isEventStudy
                ? language.notEnoughDataEventStudy()
                : language.notEnoughDataProgress()
            }
          />

          <S2Typography
            variant="body-7"
            translatedContent={
              isEventStudy
                ? language.adjustFiltersEventStudy()
                : language.adjustFiltersProgress()
            }
          />
        </Spacing>
      </Box>
    </Box>
  );
};
